import { resolveNotificationsApi } from "@/api/parentsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";

export interface ResolveNotificationsParams {
    notificationIds: number[];
    instant?: boolean;
}

export interface NotificationResponse {
    success: boolean;
    message: string;
    data: {
        resolvedIds: number[];
    };
}

export const resolveNotifications = createAsyncThunk<
    NotificationResponse,
    ResolveNotificationsParams,
    { rejectValue: string }
>("resolveNotifications", async ({ notificationIds, instant }, { rejectWithValue }) => {
    try {
        const response = await resolveNotificationsApi({ notificationIds, instant });

        return response.data;
    } catch (error) {
        if (error instanceof Error) {
            return rejectWithValue(error.message);
        }
        return rejectWithValue("Failed to resolve notifications");
    }
});
